export default "__VITE_ASSET__CJIXQ_L8__"